

export function setLocalStorageEnumMap(enumMap) {
    window.localStorage.removeItem("ENUMMAP_KEY");
    window.localStorage.setItem(
      "ENUMMAP_KEY",
      JSON.stringify(Array.from(enumMap))
    );
    const tempMap = new Map(enumMap);
    return tempMap;
}

export function getLocalStorageEnumMap() {
    const stored = window.localStorage.getItem("ENUMMAP_KEY");
    if (!stored) {
        return new Map();
    }

    try {
        const arr = JSON.parse(stored);
        if (!arr || !Array.isArray(arr)) {
            return new Map();
        }

        const enumMap = new Map();
        for (const ele in arr) {
            if (arr[ele] && Array.isArray(arr[ele]) && arr[ele].length >= 2) {
                enumMap.set(arr[ele][0], arr[ele][1]);
            }
        }
        return enumMap;
    } catch (error) {
        console.error('Failed to parse ENUMMAP_KEY from localStorage:', error);
        return new Map();
    }
}

export function clearLocalStorageEnumMap() {
    window.localStorage.removeItem("ENUMMAP_KEY");
}

export function cleanEnumMap(enumMap) {
    // Remove any element in the enumMap where the value is undefined
    const cleanedMap = new Map();
    enumMap.forEach((value, key) => {
        if (value !== undefined && value !== null) {
            cleanedMap.set(key, value);
        }
    });
    return cleanedMap;
}